import { configHome, configTeaser, DataSource } from "@pub/config";
import placeholders from "@pub/placeholders";
import {
  AnchorBlock,
  ContentBlock,
  LatestArticle,
  SectionContext,
} from "@sphtech/dmg-design-system";
import cx from "classnames";
import { ReactElement } from "react";

import styles from "../homelayout.module.css";
import { extractHomeContentData, HomeLayoutProps } from "./utils";

type Props = {
  data: HomeLayoutProps["data"];
  dataSource: DataSource;
  alternateBg?: boolean;
};

/**
 * Description: ContentBlock 5 items | Content Block A (5 tiles)
 */
export default function HomeContentBlockA({
  data,
  dataSource,
  alternateBg,
}: Props): ReactElement {
  const ContentBlock5Items = extractHomeContentData(data, dataSource);

  return (
    <div
      className={cx(
        alternateBg && styles.backgroundFill,
        styles.bodyContainer,
        styles.gutterTopBottom,
      )}
    >
      {ContentBlock5Items && (
        <ContentBlock
          inlineGutter={true}
          heading={ContentBlock5Items.title}
          cta={{
            name: "VIEW ALL",
            url: ContentBlock5Items.url,
            icon: configHome.viewMore?.icon,
          }}
          withDivider={configHome.headingDivider}
          isHeadingClickable={configHome.isHeadingClickable}
        >
          <SectionContext.Provider
            value={{
              uniqueName: ContentBlock5Items.uniqSectionName,
            }}
          >
            <div className={styles.contentBlockFiveItemsContainer}>
              {ContentBlock5Items.items.map((item, index) => {
                return (
                  <div key={index} className={styles.contentBlockFiveItems}>
                    {index === 0 ? (
                      <div className={styles.bodyContainer}>
                        <AnchorBlock
                          {...item}
                          loading="lazy"
                          placeholder={placeholders.landscape}
                          mobileCrop={configTeaser.anchorBlock?.mobileCrop}
                          CustomHeadingElement="h3"
                        />
                      </div>
                    ) : (
                      <div className={styles.mDownGutterSides}>
                        <LatestArticle
                          {...item}
                          mode={index === 4 ? "portrait" : "landscape"}
                          placeholders={placeholders}
                          displayPublishDate={configTeaser.publishDate}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </SectionContext.Provider>
        </ContentBlock>
      )}
    </div>
  );
}
